import { translate } from '../../../../../react/features/base/i18n/functions';
import React, { Component } from 'react';
import { connect } from 'react-redux';

/**
 * The type of the React {@code Component} props of {@link HintsStats}.
 */
type Props = {

    /**
     * The function to translate human-readable text.
     */
    t: Function,
    topFiveUsers: Array
};

class HintsStats extends Component<Props> {
    constructor(props) {
        super(props);

        this.renderUserStats = this.renderUserStats.bind(this);
    }

    renderUserStats(user, index) {
        return (
            <React.Fragment key = { index }>
                <div className = 'hints-stats__name'>
                    {user.displayName}
                </div>
                <div>{user.ratio}%</div>
            </React.Fragment>
        );
    }

    render() {
        const { topFiveUsers, t } = this.props;

        return (
            <div className = 'hints-stats'>
                <div className = 'hints-stats__title'>{t('hints.talkRatio')}:</div>
                {topFiveUsers.map((u, idx) => this.renderUserStats(u, idx))}
            </div>
        );
    }
}

function _mapStateToProps(state) {
    const users = Object.values(state['wildix/features/hints'].data);
    const topFiveUsers = users
        .sort((a, b) => b.ratio - a.ratio)
        .slice(0, 5);

    return {
        topFiveUsers
    };
}

export default translate(connect(_mapStateToProps)(HintsStats));
